import { type AccountMapInput, type AccountMapSuccess, HOUR } from '@terros/common'
import { keepPreviousData, type QueryKey } from '@tanstack/react-query'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'

export const accountMapQueryKey = (input: AccountMapInput): QueryKey => ['account-map', input]

export function useAccountMap(input: AccountMapInput, enabled: boolean = true): GetHookResponse<AccountMapSuccess> {
  return useTantalimQuery<AccountMapInput, AccountMapSuccess, AccountMapSuccess>({
    url: '/account/map',
    queryKey: accountMapQueryKey(input),
    input,
    convertResponse: (data) => data,
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      enabled,
      placeholderData: keepPreviousData,
    },
  })
}
